/** Still image for a clip card. Prefer the exported 9:16 poster; fall back
 *  to any source-frame thumbnail. Images are cheap on iOS; live Remotion /
 *  <video> decoders are not. */
export function resolveClipCardStillUrl(clip: {
  finished_video_thumbnail_url?: string | null;
  thumbnail_url?: string | null;
  data?: { clip_thumbnail?: string | null } | null;
}): string | null {
  const still =
    clip.finished_video_thumbnail_url
    || clip.thumbnail_url
    || clip.data?.clip_thumbnail
    || null;
  return still || null;
}

/** Mount the live Remotion / native player only after the user taps play.
 *  Mounting one paused ProjectPreview per card is what jetsams iOS Safari
 *  on /library/:id/clips (dozens of 1080×1920 decoders). */
export function shouldMountClipCardLivePreview(input: {
  isPlayerMounted: boolean;
  hasSourceVideo: boolean;
  hasPreviewTimeRange: boolean;
  isRendered: boolean;
  showLivePreview: boolean;
}): boolean {
  if (!input.isPlayerMounted) return false;
  if (!input.hasSourceVideo || !input.hasPreviewTimeRange) return false;
  return !input.isRendered || input.showLivePreview;
}
